<template>
	<div class=" pl-3 pr-3">
		<div class="row">
			<div class="col-md-6 ">
				<div class="row">
					<div class="Aligner-Header col-md-6 col-12 mt-2 pt-3">
						<h4>Market Contribution</h4>
					</div>
					<div class="col-md-4 col-12 mt-2 pt-3">
						<button class="btn btn-outline-primary w-100" @click="showModal = !showModal">{{showModal ? 'Hide' : 'Show'}} Table</button>
					</div>
				</div>
				<div class="row" v-if="showModal">
					<div class="col-md-12 pl-3">
						<h5>Detail {{type}}</h5>
						<hr>
						<span><span class="h6">Total Sales Kecamatan : {{numberWithCommas(totalSalesKecamatan)}}</span> <span class="h6 ml-3" v-if="type != 'Kecamatan'">Sum of Total Sales : {{numberWithCommas(sumOfTotalSales)}}</span></span>
					</div>
				</div>
			</div>
			<div class="col-md-6" v-if="showModal">
				<div class="row mt-3">
					<div class="offset-md-6 col-md-3" style="padding-right:0">
						<button 
							style="border-radius : 6px 0px 0px 6px"
							type="button" 
							class="w-100 btn" 
							:class="(type == 'Kecamatan') ? 'btn-primary' : 'btn-outline-primary'" 
							@click="type = 'Kecamatan'"
						>
							Kecamatan
						</button>
					</div>
					<div class="col-md-3" style="padding-left:0">
						<button 
							style="border-radius : 0px 6px 6px 0px"
							type="button" 
							class="w-100 btn" 
							:class="(type == 'Dealer') ? 'btn-primary' : 'btn-outline-primary'" 
							@click="type = 'Dealer'"
						>
							Dealer
						</button>
					</div>
				</div>
				<div class="row">
					<div class="col-md-2 col-12 offset-md-2 highlightFilter">
						<label v-if="type == 'Kecamatan'">Sales By</label>
						<toggle-button
							v-if="type == 'Kecamatan'"
							v-model="changeDocument"
							:width="90"
							:height="25"
							color="#7dCE94" 
							:sync="true" 
							:labels="{checked: 'Document', unchecked: 'Scan'}"
							
						/>
					</div>
					<div class="col-md-4 col-12 mt-2 highlightFilter pl-4">
						<Multiselect
							class="mt-1 "
							:options="dealerRadiusLegend.map(x => x.desc.toUpperCase())"
							:allow-empty="true"
							v-model="setRing"
							placeholder="All Radius"
						/>
					</div>
					<div class="col-md-4 col-12 mt-2 pt-3 pl-4" :class="{'offset-md-4' : !showModal}" v-if="showModal">
						<button class="btn btn-primary w-100" style="height:41px" @click="download">Download CSV</button>
					</div>
				</div>
				
			</div>
			
			
		</div>
		<!-- {{setRing}} -->
		<div v-if="showModal">
			<!-- Table Kecamatan -->
			<table class="table mt-3 text-center" v-if="type == 'Kecamatan'">
				<thead>
					<th>Kecamatan</th>
					<th>Ring</th>
					<th>Total Sales From All Dealer</th>
					<th>Sales From Selected Dealer</th>
					<th>Contribution From Selected Dealer</th>
					<th>Contribution From All Dealer</th>
					<th></th>
				</thead>
				<tbody v-for="data in showData" :key="data.nama_kecamatan">
					<tr class="hoverTr" style="cursor:pointer" @click="data.hideTab = !data.hideTab">
						<td>{{data.nama_kecamatan}}
						</td>
						<td>{{data.ring}}</td>
						<td>{{numberWithCommas(data.total_sales_all_dealer)}}</td>
						<td>{{numberWithCommas(data.sales)}}</td>
						<td>{{data.contribution}} %</td>
						<td>{{data.market_contribution}} %</td>
						
						<td>
							
							<i class="fa fa-chevron-right" v-if="!data.hideTab"></i>
							<i class="fa fa-chevron-down" v-else></i>
						</td>
					</tr>
					<tr v-if="data.hideTab">
						<td colspan="7" class="pr-4 pl-4">
							<table class="table table-dark" >
								<thead >
									<th>Kelurahan</th>
									<th>Sales From Selected Dealer</th>
									<th>Contribution From Selected Dealer</th>
									<th>Contribution From All Dealer</th>
									<!-- <th>Total Sales All Dealer</th> -->
									<th></th>
								</thead>
								<tbody v-for="kelu in data.data_kelurahan" :key="kelu.nama_kelurahan">
									<td>{{kelu.nama_kelurahan}}</td>
									<td>{{numberWithCommas(kelu.sales)}}</td>
									<td>{{kelu.contribution}} %</td>
									<td>{{kelu.market_contribution}} %</td>
									<!-- <td>{{numberWithCommas(kelu.total_sales_all_dealer)}}</td> -->
								</tbody>
							</table>
						</td>
					</tr>
				</tbody>
			</table>
			<!-- Table Kecamatan -->

			<!-- Table Dealer -->
			<table class="table mt-3 text-center" v-else>
				<thead>
					<th>Kecamatan</th>
					<th>Sales Dealer</th>
					<th>% Contribution</th>
					<th></th>
				</thead>
				<tbody v-for="data in showData" :key="data.nama_kecamatan">
					<tr class="hoverTr" style="cursor:pointer" @click="data.hideTab = !data.hideTab">
						<td>{{data.nama_kecamatan}}
						</td>
						<td>{{numberWithCommas(data.total_sales_per_kecamatan)}}</td>
						<td>{{data.contribution}} %</td>
						
						<td>
							
							<i class="fa fa-chevron-right" v-if="!data.hideTab"></i>
							<i class="fa fa-chevron-down" v-else></i>
						</td>
					</tr>
					<tr v-if="data.hideTab">
						<td colspan="7" class="pr-4 pl-4">
							<table class="table table-dark" >
								<thead >
									<th>Dealer</th>
									<th>Sales Dealer</th>
									<th>% Contribution</th>
									<th></th>
								</thead>
								<tbody v-for="dealer in data.data_dealer" :key="dealer.dealer">
									<td>{{dealer.dealer}}</td>
									<td>{{numberWithCommas(dealer.sales)}}</td>
									<td>{{dealer.contribution}} %</td>
								</tbody>
							</table>
						</td>
					</tr>
				</tbody>
			</table>
			<!-- Table Dealer -->

			<div class="mt-5 pl-3 pr-3">
				<button v-if="!trendSales" class="w-100 btn btn-primary" @click="$router.push({name : 'MCDReport'})">Go To Target Sales Kecamatan</button>
			</div>
		</div>
	</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
const XLSX = require('xlsx')
import { ToggleButton } from 'vue-js-toggle-button'

export default {
	components : {
		Multiselect,
		ToggleButton

	},
	data () {
		return {
			showModal : false,
			hideTabs : null,
			setRing : '',
			showData : null,
			originalData : null,
			originalDataDocs : null,
			originalDataMarket : null,
			changeDocument : false,
			data : null,
			selectedData : null,
			totalSalesKecamatan : 0,
			sumOfTotalSales : 0,
			type : 'Kecamatan'
		}
	},
	watch : {
		setRing : function () {
			this.resetData()
		},
		changeDocument : function() {
			this.changeDocumentData()
		},
		type : function () {
			if(this.type == 'Kecamatan') {
				this.changeDocumentData()
			}
			else {
				this.selectedData = this.originalDataMarket
				this.showData = this.selectedData.slice()

				this.sumOfTotalSales = this.showData[0] ? this.showData[0].total_sales_all : 0

				this.setDetail()
			}
		}
	},
	props : ['dataMarket' , 'dealerRadiusLegend' , 'dataMarketDocs' , 'dataMarketDealer' , 'trendSales'],
	mounted () {
		// console.log(this.dataMarket)
		this.originalData = Object.values(this.dataMarket)
		this.originalDataDocs = Object.values(this.dataMarketDocs)
		this.originalDataMarket = Object.values(this.dataMarketDealer)
		// let arr = new Array(keys.length).fill(false)
		for(var i = 0; i < this.originalData.length ; i++) {
			this.$set(this.originalData[i] , 'hideTab' , false)
		}

		for(var i = 0; i < this.originalDataDocs.length ; i++) {
			this.$set(this.originalDataDocs[i] , 'hideTab' , false)
		}
		
		for(var i = 0; i < this.originalDataMarket.length ; i++) {
			this.$set(this.originalDataMarket[i] , 'hideTab' , false)
		}

		this.showData = this.originalData
		this.selectedData = this.originalData

		this.setDetail()
		this.resetData()
		
	},
	methods : {
		changeDocumentData () {
			if(!this.changeDocument) {
				this.selectedData = this.originalData
			}
			else {
				this.selectedData = this.originalDataDocs
			}

			this.setDetail()
			this.resetData()
		},
		setDetail () {
			if(this.selectedData[0]) {
				this.totalSalesKecamatan = this.selectedData[0].total_sales_all_kecamatan
			}
			else {
				this.totalSalesKecamatan = 0
			}
		},
		resetData() {
			if(this.setRing == '' || !this.setRing) {
				this.showData = this.selectedData.slice()
				return
			}

			let ring = this.setRing == 'OTHERS' ? 'OTHER' : this.setRing
			this.showData = this.selectedData.filter(x => x.ring == ring)
			
			this.setDetail()
		},
		download () {
			this.$swal.fire({
				title: '<strong>Download Excel</strong>',
				type: 'info',
				html:
					'Pick location for downloading the excel for market contribution.',
				showCloseButton: true,
				showCancelButton: true,
				focusConfirm: false,
				confirmButtonText:
					`Current Location (${this.setRing ? this.setRing : 'All Location'})`,
				cancelButtonText:
					'All Location',
			}).then((result) => {
				// console.log(result)
				if (result.value == true) {
					this.exportExcel('showData')
				}
				else if(result.dismiss == 'cancel') {
					this.exportExcel('selectedData')
				}
			})
			
		},
		exportExcel (type) {
			let wb = XLSX.utils.book_new()
			let allData = this[type]
			// First Sheet  , All Kecamatan
			let firstSheetData = allData.map(x => x = {
				'Kecamatan' : x.nama_kecamatan,
				'Jumlah' : x.sales,
				'% Contribution Dealer' : x.contribution + ' %',
				'% Contribution All Dealer' : x.market_contribution + ' %',
				'Total Sales All Dealer' : x.total_sales_all_dealer
			})
			// console.log(firstSheetData)

            var ws = XLSX.utils.json_to_sheet(firstSheetData, { raw: "true" });
            XLSX.utils.book_append_sheet(wb, ws, 'Market Contribution Kecamatan')

			for(var i = 0 ; i < allData.length ; i++) {
				let curKec = allData[i]
				// console.log(curKec)

				let sheetData = curKec.data_kelurahan.map(x => x = {
					'Kelurahan' : x.nama_kelurahan,
					'Jumlah' : x.sales,
					'% Contribution Dealer' : x.contribution + ' %',
					'% Contribution All Dealer' : x.market_contribution + ' %',
					'Total Sales All Dealer' : x.total_sales_all_dealer
				})

				var ws = XLSX.utils.json_to_sheet(sheetData, { raw: "true" });
				XLSX.utils.book_append_sheet(wb, ws, curKec.nama_kecamatan)
			}
            XLSX.writeFile(wb, `Market Contribution.xls`)
		}
	}
}
</script>

<style scoped>
	.hoverTr:hover {
		background-color:rgb(219, 219, 219);
	}
	.btn-primary {
		background-color: #FF9700;
		border-color: #FF9700;
		border-color: transparent;
		color:white !important;
	}
	
</style>
<style scoped>
	.h3title{
		margin: 0 0 8px 0;
		font-weight:600;
		line-height:1.2;
		font-size: x-large;
		display:block;
		margin-inline-start: 0;
		margin-inline-end: 0;
		color:#707070;
	}

	h5 {
		color: #707070;
	}
	.h6 {
		color: #707070;
	}
	.btn-outline-primary {
		border-color: #FF9700;
		background-color: white !important;
		color : #FF9700;
	}

	.btn-outline-primary:hover {
		background-color: #FF9700 !important;
		color: white !important;
	}

	.btn-outline-primary:focus {
		background-color:#FF9700;
	}
</style>